/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../../utils/commonFunctions';

const allUserDetails = async (data: Record<string, any> = {}): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const {company, facility} = useUserStore.getState().userDetails;
  const {stackholderType} = data;
  const params = {...data};
  delete params.stackholderType;
  if (stackholderType === 'External') {
    delete params.memberType;
  }

  const url = `${API_BASE_URL}${API_ENDPOINT_JSON.getAllUsers}/${company}/${
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user)
      ? 'null/'
      : `${facility}/`
  }${stackholderType || 'Internal'}`;

  try {
    const res: any = await axios.request({
      method: CRUDMethods.GET,
      url,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    });

    return res.data.data;
  } catch (err) {
    return [];
  }
};

export default allUserDetails;
